import { Injectable, Injector } from "@angular/core";
import { EmployeeRecord } from "../entities/employee-record";
import { BaseCrudService } from "../../shared/_utils/services/base-crud-service";
import { LazyLoadEvent } from "primeng/primeng";
import { HttpParams } from "@angular/common/http";
import { QueryOperator } from "../../shared/_utils/services/query-operator.enum";

@Injectable()
export class EmployeeRecordService extends BaseCrudService<EmployeeRecord> {

    public uri = '/api/employeeRecord/';

    constructor(injector: Injector){
        super(injector);
       //console.log('Instance employeeRecordService');
    }

    buildSentence(entity?: EmployeeRecord, event?: LazyLoadEvent): HttpParams {
        if (entity) {
          let query = '';
          query = query.concat(
            entity.row ? 
              `row${QueryOperator.Equal}${entity.row}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.startDate ? 
              `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.endDate ? 
              `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.receptionDate ? 
              `receptionDate${QueryOperator.Equal}${entity.receptionDate}${QueryOperator.Split}`
              : QueryOperator.Empty
          );
          query = query.concat(
            entity.comment ? 
              `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
              : QueryOperator.Empty
          );                              
          if (entity.employee && entity.employee.id) {
            query = query.concat(
              `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
            );
          };
          if (entity.supportingDocument && entity.supportingDocument.id) {
            query = query.concat(
              `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
            );
          };
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }
    
        if (event) {
          const page = ((event.first + event.rows) / event.rows - 1).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
      }
}    


// WEBPACK FOOTER //
// ./src/app/core/services/employee-record.service.ts